import React, { Component } from "react";
import PropTypes from "prop-types";
import * as Theme from "../../../app/Theme";
import TButton from "../../common/TButton";
import * as HLConst from "../NonVisual/HLConst";
import {} from "../NonVisual/HLUtil";

class HLNavBtnDiv extends Component {
    static propTypes = {
        divStyle: PropTypes.object,

        showBackBtn: PropTypes.bool,
        showNextBtn: PropTypes.bool,

        onBackBtnClick: PropTypes.func,
        onNextBtnClick: PropTypes.func,
    };

    static defaultProps = {
        divStyle: {},

        showBackBtn: true,
        showNextBtn: true,

        onBackBtnClick: () => console.log("onBackBtnClick"),
        onNextBtnClick: () => console.log("onNextBtnClick"),
    };

    state = {};

    //==================================================================================================================
    //
    //                                              Event Handlers
    //
    //==================================================================================================================

    onBackBtnClick = () => {
        this.props.onBackBtnClick();
    };

    onNextBtnClick = () => {
        this.props.onNextBtnClick();
    };

    //==================================================================================================================
    //
    //                                                 Render
    //
    //==================================================================================================================

    render() {
        const showBackBtn = this.props.showBackBtn;
        const showNextBtn = this.props.showNextBtn;

        let backBtn = null;

        if (showBackBtn) {
            backBtn = (
                <TButton
                    caption={HLConst.backBtnText}
                    captionStyles={{
                        fontSize: 16,
                        ...Theme.labelFontStyle,
                        marginTop: 5,
                        marginBottom: 5,
                    }}
                    containerStyle={{
                        display: "inline-block",
                        fontFamily: Theme.fontFamily,
                        marginBottom: 10,
                        marginLeft: Theme.leftIndent,
                        marginTop: Theme.topIndent,
                    }}
                    key={"backBtn"}
                    style={{
                        backgroundColor: Theme.HL_BtnBackgroundColor,
                        fontFamily: Theme.fontFamily,
                    }}
                    onClick={this.onBackBtnClick}
                />
            );
        }

        let nextBtn = null;

        if (showNextBtn) {
            nextBtn = (
                <TButton
                    caption={HLConst.nextBtnText}
                    captionStyles={{
                        fontSize: 16,
                        ...Theme.labelFontStyle,
                        marginTop: 5,
                        marginBottom: 5,
                    }}
                    containerStyle={{
                        display: "inline-block",
                        fontFamily: Theme.fontFamily,
                        marginBottom: 20,
                        marginLeft: Theme.leftIndent,
                        marginTop: Theme.topIndent,
                    }}
                    key={"nextBtn"}
                    style={{
                        backgroundColor: Theme.HL_BtnBackgroundColor,
                        fontFamily: Theme.fontFamily,
                    }}
                    onClick={this.onNextBtnClick}
                />
            );
        }

        return (
            <div key={"HLNavBtnDiv"} style={this.props.divStyle}>
                {backBtn}
                {nextBtn}
            </div>
        );
    }
}

export default HLNavBtnDiv;
